export const e164Regex = /^\+{0,1}\d{0,15}$/;
